// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_BACK = "Zp\u011bt";
